import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Box, Grid, Card, CardContent, CardHeader, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';

import { AreaChart, ResponsiveContainer, Legend, Bar, Tooltip, BarChart, LineChart, Line, CartesianGrid, XAxis, YAxis } from 'recharts';

const example_data = [
    { name: 'Page Z', uv: 550, pv: 2400, amt: 2400 },
    { name: 'Page A', uv: 200, pv: 2400, amt: 4400 },
    { name: 'Page B', uv: 200, pv: 1400, amt: 100 },
    { name: 'Page C', uv: 300, pv: 2200, amt: 2200 },
    { name: 'Page D', uv: 400, pv: 1300, amt: 1400 },];

const ProjectHistoryTimeView = props => {
    const navigate = useNavigate()
    // const { data, total, isLoading } = useGetList('resource_history', {
    //     pagination: { page: 1, perPage: 10 },
    //     sort: { field: 'reg_date', order: 'DESC' },
    // });

    // const listContext = useList({ data, isLoading });

    const [chart, setChart] = useState({
        legend: [],
        data:[],
    })

    useEffect(() => {
        update('day')
    }, [])

    const update = (type) => {
        let url = `/api/history/summary?type=${type}&project_id=${props.project_id}`
        client.request_get(url).then(res => {
            setChart(res)
        })
    }
    
    return (
        <Card variant="outlined">
            <CardHeader titleTypographyProps={{ variant: 'h9' }} title="Hourly Resource Usage"
                action={
                    <Box>
                        <Button onClick={() => { update('day') }} >Daily</Button>
                        <Button onClick={() => { update('week') }}>Weekly</Button>
                        <Button onClick={() => { update('month') }}>Monthly</Button>
                        <Button onClick={() => { update('total') }}>Total</Button>
                        <Button onClick={() => { navigate('/resource_history') }}>List</Button>
                    </Box>
                }
            />
            <CardContent>
                <Box width='100%' height='300px'>
                    <ResponsiveContainer height='100%' width='100%'>
                        <BarChart data={chart.row} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                            <XAxis dataKey="name" />
                            <YAxis type="number" domain={[0, 16]} />
                            <Tooltip />
                            <CartesianGrid stroke="#f5f5f5" />
                            {
                                chart.legend && chart.legend.map((m, i) => (
                                    <Bar dataKey={m.name} fill={m.color} />
                                ))
                            }
                            
                            <Legend/>
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProjectHistoryTimeView;
